module.exports = __webpack_public_path__ + "img/why-us-card-img-3.5dba6e78.svg";